import React, {useCallback, useEffect, useState} from 'react';
import {State, ViewStates} from "@common/components/view-states";
import {ViewState} from "@common/models/enums/viev-state.enum";
import {StatisticsResponse} from "../features/core/models/interfaces/statistics-dto.interface";
import {useLoading} from "../features/core/hooks/use-loading.hook";
import {useStatisticsApi} from "../features/core/hooks/use-statistics-api";
import {LoadingKeys} from "../features/core/models/enums/loading-keys.enum";
import StatisticsGrid from "../features/statistics/components/statistics-grid";
import TopArticlesTable from "../features/statistics/components/top-articles-table";


const DashboardPage: React.FC = () => {
    const { getStatistics, error } = useStatisticsApi();
    const { isLoading } = useLoading();
    const [data, setData] = useState<StatisticsResponse | null>(null);

    const fetchData = useCallback(async () => {
        const result = await getStatistics();
        setData(result);
    }, []);

    useEffect(() => {
        void fetchData();
    }, [fetchData]);

    return (
        <div className="flex w-full p-8 overflow-y-auto">
            <div className="max-w-[800px] mx-auto">
                <ViewStates loading={isLoading([LoadingKeys.USE_STATISTICS_API, 'getStatistics'])} error={error} data={data}>
                    <State state={ViewState.LOADING} />
                    <State state={ViewState.EMPTY}>
                        <p className="text-gray-400">Brak danych statystycznych</p>
                    </State>
                    <State state={ViewState.FETCHED}>
                        <div className="flex flex-col gap-12">
                            <StatisticsGrid statistics={data} />
                            <TopArticlesTable articles={data?.articleViews ?? []} />
                        </div>
                    </State>
                    <State state={ViewState.ERROR} />
                </ViewStates>
            </div>
        </div>
    );
};

export default DashboardPage;
